export enum TimeFrameOption {
  lastTwelveMonth = 'lastTwelveMonth',
  thisYear = 'thisYear',
  thisMonth = 'thisMonth',
  individual = 'individual',
  allTime = 'allTime',
}
